export const NotificationScope = {
  WEBAPP_PPOINT: 'WEBAPP_PPOINT',
} as const;

export enum NotificationActionType {
  DISMISS = 'DISMISS',
  URL = 'URL',
}
export interface NotificationAction {
  type: NotificationActionType;
  objectiveId?: string;
}

export type NotificationButtonType = 'PRIMARY' | 'SECONDARY';
export const NotificationIconTypes = {
  APPROVED: 'APPROVED',
  DENIED: 'DENIED',
  CLOCK: 'CLOCK',
  LETTER: 'LETTER',
};

export const NotificationTypeList = [
  // TODO fill
  'ROUTE_ASSIGN_REQUEST',
  'GENERAL',
] as const;

export const NotificationTypes = {
  // TODO fill
  ROUTE_ASSIGN_REQUEST: 'ROUTE_ASSIGN_REQUEST',
  GENERAL: 'GENERAL',
};

export type NotificationType = keyof typeof NotificationTypes;

export interface NotificationImage {
  src: string;
  shape: 'SQUARE' | 'CIRCULAR';
}
type NotificationStatus = {
  SEEN: 'seen';
  UNSEEN: 'unseen';
  DELETED: 'deleted';
};

export interface NotificationButton {
  title: string;
  type: NotificationButtonType;
  action: NotificationAction;
}

export interface INotification {
  id: string;
  title: string;
  description?: string;
  push: boolean;
  type?: NotificationType;
  creationTimestamp?: string;
  seenTimestamp?: string;
  sendEmail?: boolean;
  images?: {
    main?: NotificationImage;
    left?: NotificationImage[];
    right?: NotificationImage[];
  };
  buttons?: NotificationButton[];
  action?: NotificationAction;
  icon?: keyof typeof NotificationIconTypes;
  scope?: keyof typeof NotificationScope;
  url?: string;
  recipients: string[];
}

export interface PushNotification {
  title: string;
  body: string;
  icon?: string;
  image?: string;
}
